import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/img/outcess-logo.png";
import Button from "../pages/USA/USA-Components/ButtonUi";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoClose } from "react-icons/io5";



const Navbar = ({ variant }) => {
  const [displayNav, setDisplayNav] = useState(false);
  const [company, setCompany] = useState(false);
  const [solutions, setSolutions] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [isVisible, setIsVisible] = useState(false)

  const USlinks = {
    'Services': '/us/services',
    'Industries': '/us/industries',
    'About Us': '/us/about Us',
    'Contact US': '/us/contact us',
  }

  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Detect direction
      if (currentScrollY > lastScrollY.current && currentScrollY > 80) {
        // Scrolling DOWN
        setHidden(true);
      } else {
        // Scrolling UP
        setHidden(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (variant === "us") {
    return (

      <div className={`${isVisible? 'xs:h-[240px] h-[240px] transition-all duration-500 ease-in-out' : 'xs:h-[50px] h-[50px]'} xl:h-auto overflow-hidden w-full fixed left-0 flex flex-col py-3 px-16 xs:px-2 bg-[#f5f3f4] z-[70] transition-all duration-300 ease-in-out
      ${hidden ? "-top-24" : "top-0"}
    `}>

      {/* main interface for desktop View  */}
      <div className="w-full flex justify-between items-center ">
        <NavLink to={'/us'}><img src={Logo} className="w-40 contain" alt="logo" /></NavLink>

        <div className={`w-[30%] justify-between items-center hidden flex-col xl:flex xl:flex-row`}>
          {Object.keys(USlinks).map((key) => (
            <NavLink key={key} to={USlinks[key]}
            exact
            className="text-base font-medium hover:text-primary-orange"
            activeClassName="text-[#ff6600] underline decoration-primary-orange"
            >{key}</NavLink>
          ))}
        </div>
        <div 
  onClick={() => setIsVisible(!isVisible)}
  className={`
    text-2xl xl:hidden sm:inline-block
    transition-transform duration-500 ease-in-out
    ${isVisible ? 'rotate-180' : 'rotate-0'}
  `}
>
  {isVisible ? <IoClose /> : <GiHamburgerMenu />}
</div>
        <Button variant="primary" className="xl:inline xs:hidden sm:hidden">Get started</Button>
      </div>

          {/* only applies in mobile view */}
        <div className="w-[50%] pl-12 justify-between flex xs:flex xl:hidden flex-col gap-2 xl:flex-row mt-2">
          {Object.keys(USlinks).map((key) => (
            <NavLink key={key} to={USlinks[key]}
            exact
            className="text-base font-medium hover:text-primary-orange"
            activeClassName="text-[#ff6600] underline decoration-primary-orange"
            >{key}</NavLink>
          ))}
          <Button variant="primary" className="text-center md:p-3">Get started</Button>
        </div>
      </div>
    
    );
  }

  return (
    <nav id="navbar">
      <div id="logo">
        <NavLink to="/" exact>
          <img src={Logo} alt="Outcess" />
        </NavLink>
      </div>
      <div className="bg-screen-nav">
        <ul className="bg-nav-ul">
          <li
            onMouseEnter={() => setCompany(true)}
            onMouseLeave={() => setCompany(false)}
          >
            <p className="bg-screen-nav-title">Company</p>
            <div
              className={
                company ? "bg-screen-sub-menu display" : "bg-screen-sub-menu"
              }
            >
              <ul>
                <li>
                  <NavLink to="/about" activeClassName="active-link" exact>
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/business-partners"
                    activeClassName="active-link"
                    exact
                  >
                    Business Partners
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/ideology" activeClassName="active-link" exact>
                    Ideology
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/outcess-clients"
                    activeClassName="active-link"
                    exact
                  >
                    Clients
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/gallary" activeClassName="active-link" exact>
                    Gallery
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/faqs" activeClassName="active-link" exact>
                    FAQ
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li
            onMouseEnter={() => setSolutions(true)}
            onMouseLeave={() => setSolutions(false)}
          >
            <p className="bg-screen-nav-title">Solutions</p>
            <div
              className={
                solutions ? "bg-screen-sub-menu display" : "bg-screen-sub-menu"
              }
            >
              <ul>
                <li>
                  <NavLink
                    to="/business-process-outsourcing"
                    activeClassName="active-link"
                    exact
                  >
                    Business Process Outsourcing
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/business-productivity-solutions"
                    activeClassName="active-link"
                    exact
                  >
                    Business Productivity Solutions
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/cloud-solutions"
                    activeClassName="active-link"
                    exact
                  >
                    Cloud Solutions
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/customer-engagement-Solutions"
                    activeClassName="active-link"
                    exact
                  >
                    Customer Engagement Solutions
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/omni-channel-marketing"
                    activeClassName="active-link"
                    exact
                  >
                    Omni-Channel Digital Marketing
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/aml-solutions"
                    activeClassName="active-link"
                    exact
                  >
                    Anti-Money Laundering (AML) Solutions
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/clm-solutions"
                    activeClassName="active-link"
                    exact
                  >
                    Customer Lifecycle Management (CLM) Solutions
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <NavLink to="/case-studies" className="bg-screen-nav-title" exact>
              Case Studies
            </NavLink>
          </li>
          <li>
            <li>
              <NavLink to="/careers" activeClassName="active-link" exact>
                Careers
              </NavLink>
            </li>
          </li>
          <li>
            <NavLink to="/contact-us" className="bg-screen-nav-title" exact>
              BOOK A DEMO
            </NavLink>
          </li>
        </ul>
        <NavLink
          to="/be-work-from-home-ready"
          activeClassName="active-link"
          exact
        >
          <button>Be remote ready</button>
        </NavLink>
      </div>
      <div className="sm-screen-nav">
        <div
          className={displayNav ? "menu-btn close" : "menu-btn"}
          onClick={() => setDisplayNav(!displayNav)}
        >
          <div className="btn-line" />
          <div className="btn-line" />
          <div className="btn-line" />
        </div>
        <div
          className={
            displayNav ? "menu-container display-menu" : "menu-container"
          }
        >
          <div className="menu-content">
            <NavLink
              to="/be-work-from-home-ready"
              activeClassName="active-link"
              exact
            >
              <button> Be remote ready</button>
            </NavLink>
            <div className="menu-grid">
              <div className="menu-grid-details">
                <p>Company</p>
                <ul>
                  <li>
                    <NavLink to="/about" activeClassName="active-link" exact>
                      About Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/business-partners"
                      activeClassName="active-link"
                      exact
                    >
                      Business Partners
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/ideology" activeClassName="active-link" exact>
                      Ideology
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/isoqualitystatement"
                      activeClassName="active-link"
                      exact
                    >
                      ISO Quality Statement
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/outcess-clients"
                      activeClassName="active-link"
                      exact
                    >
                      Clients
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/careers" activeClassName="active-link" exact>
                      Careers
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/gallary" activeClassName="active-link" exact>
                      Gallery
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div className="menu-grid-details">
                <p>Case Study</p>
                <ul>
                  <li>
                    <NavLink
                      to="/case-studies"
                      className="bg-screen-nav-title"
                      exact
                    >
                      Categories
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="menu-grid-details">
              <p>Solutions</p>
              <ul>
                <li>
                  <NavLink
                    to="/business-process-outsourcing"
                    activeClassName="active-link"
                    exact
                  >
                    Business Process Outsourcing
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/business-productivity-solutions"
                    activeClassName="active-link"
                    exact
                  >
                    Business Productivity Solutions
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/cloud-solutions"
                    activeClassName="active-link"
                    exact
                  >
                    Cloud Solutions
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/customer-engagement-Solutions"
                    activeClassName="active-link"
                    exact
                  >
                    Customer Engagement Solutions
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/omni-channel-marketing"
                    activeClassName="active-link"
                    exact
                  >
                    Omni-Channel Digital Marketing
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="menu-supports">
              <ul>
                <li>
                  <NavLink to="/contact-us" activeClassName="active-link" exact>
                    Book a Demo
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/contact-us" activeClassName="active-link" exact>
                    Contact Us
                  </NavLink>
                </li>
                <li>
                  <a href="https://outcessblog.lll-ll.com/">Blog</a>
                </li>
                <li>
                  <NavLink to="/faqs" activeClassName="active-link" exact>
                    FAQ
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
